import React, { FC, memo, useCallback } from 'react';
import { Dialog, Spacing, Typography } from 'components/src';
import { TouchableOpacity } from 'react-native';
import {
  createUseStyles,
  useDeleteUserDeleteAvatar,
  usePatchUserUpdateAvatar,
  userInfo,
} from 'core/src';
import { useTranslation } from 'react-i18next';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import heic2any from 'heic2any';

const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;

interface ComponentProps {
  handleModalClose: any;
  modalVisible: any;
  refetch?: any;
}

const UpdateAvatar: FC<ComponentProps> = memo(
  ({ handleModalClose, modalVisible, refetch }) => {
    const { i18n } = useTranslation();
    const { styles, colors } = useStyles();
    //@ts-ignore
    const { avatar } = userInfo();
    const { mutate } = usePatchUserUpdateAvatar({
      onSuccess: () => {
        refetch();
        handleModalClose(true);
      },
    });

    const { mutate: removeMutate } = useDeleteUserDeleteAvatar({
      onSuccess: () => {
        refetch();
        handleModalClose(true);
      },
    });

    const handleTakePhoto = useCallback(async () => {
      document.getElementById('fileAvatar')?.click();
    }, []);

    const handleRemove = (e: any) => {
      removeMutate({
        queryParams: {
          avatarName: avatar,
        },
      });
    };

    const handleChangeFile = async (e: any) => {
      if (!e.target.files.item(0)) return;

      let file = e.target.files.item(0);

      // Check if the file is in HEIC format
      if (file.type === 'image/heic' || file.name.endsWith('.heic')) {
        try {
          const convertedBlob = await heic2any({
            blob: file,
            toType: 'image/jpeg', // Convert to JPEG format
          });

          // Handle the case where `convertedBlob` is an array
          const finalBlob = Array.isArray(convertedBlob)
            ? convertedBlob[0] // Use the first Blob from the array
            : convertedBlob;

          const convertedFile = new File([finalBlob], `${file.name}.jpeg`, {
            type: 'image/jpeg',
          });

          file = convertedFile; // Replace the file with the converted one
        } catch (error) {
          console.error('Error converting HEIC file:', error);
          return; // Exit if conversion fails
        }
      }

      const randomString = Math.random().toString(36).substring(7);
      const fileName = `${randomString}_${file.name}`;

      mutate({
        requestBody: {
          //@ts-ignore
          file: new File([file], fileName, { type: file.type }),
        },
      });
    };

    const options = [
      {
        label: i18n.t('choosePhoto'),
        icon: 'photo-camera',
        onClick: handleTakePhoto,
      },

      { label: i18n.t('remove'), icon: 'delete', onClick: handleRemove },
    ];

    return (
      <>
        <Dialog
          animationType={'fade'}
          modalVisible={modalVisible}
          handleModalClose={handleModalClose}
          classesIn={styles.modalContent}
          classesOut={styles.modalContainer}
        >
          {options.map((option: any, index: any) => (
            <TouchableOpacity
              key={index}
              style={styles.option}
              onPress={option.onClick}
            >
              <MaterialIconsX
                name={option.icon}
                size={25}
                color={colors.secondryColor}
              />
              <Spacing horizontal={2} />
              <Typography text={option.label} color={colors.secondryColor} />
            </TouchableOpacity>
          ))}
        </Dialog>
        {/* @ts-ignore */}
        <input id="fileAvatar" type="file" onChange={handleChangeFile} hidden />
      </>
    );
  },
);

const useStyles = createUseStyles(({ colors }) => ({
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    borderBottomWidth: 1,
    borderBottomColor: colors.line,
  },
  modalContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },

  modalContent: {
    width: 200,
    height: 175,
  },
}));

export { UpdateAvatar };
